/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S3_Li2Inputs */

const tr_onbilgi_s3_li2 = /** @type {(inputs: Onbilgi_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para birimi: Türk Lirası (TL).`)
};

const en_onbilgi_s3_li2 = /** @type {(inputs: Onbilgi_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency: Turkish Lira (TL).`)
};

const de_onbilgi_s3_li2 = /** @type {(inputs: Onbilgi_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Währung: Türkische Lira (TL).`)
};

const ru_onbilgi_s3_li2 = /** @type {(inputs: Onbilgi_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Валюта: турецкая лира (TL).`)
};

/**
* | output |
* | --- |
* | "Currency: Turkish Lira (TL)." |
*
* @param {Onbilgi_S3_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s3_li2 = /** @type {((inputs?: Onbilgi_S3_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S3_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s3_li2(inputs)
	if (locale === "de") return de_onbilgi_s3_li2(inputs)
	if (locale === "ru") return ru_onbilgi_s3_li2(inputs)
	return tr_onbilgi_s3_li2(inputs)
});